import React from 'react'
import { Result, Button, Input, message, Row, Col } from 'antd'
import { api, app, use } from 'xadmin'
import _ from 'lodash'
import './../ui/layout/Dashboard/home.css'

const PermissionPage = props => {
  const [ messages, setMessages ] = React.useState(null)
  const { settings } = use('settings')
  const { user } = use('redux', state => ({ user: state.user }))
  const { dispatch } = use('redux')
  const [ inputValue, setInputValue ] = React.useState(null)

  let expireSettings = settings?.pressMoney?.expireSettings

  React.useEffect(() => {
    api({ name: 'core/model' }).fetch('', {})
      .then((json) => { }).catch((err) => setMessages(err.message))
  }, [])

  const resetDisable = () => {
    if(expireSettings?.length) {
      let tipFilter = expireSettings.filter(val => {
        return val?.expireTime && !val?.disable && moment(val?.expireTime).diff(new Date(), 's') <= 0
      })
      if(tipFilter?.length) {
        let bodyStr = {
          pressMoney: {
            ...settings?.pressMoney,
            expireSettings: expireSettings.map(item => {
              if(item?.expireTime == tipFilter?.[0]?.expireTime && !item?.disable) {
                return { ...item, disable: true }
              }
              return item
            })
          }
        }
        if(!user?.isAdmin) bodyStr.pressMoney._pressMoney = true

        api({ name: 'core/setting' })
        .fetch('', {
          method: 'PATCH',
          body: JSON.stringify(bodyStr)
        })
        .then(({ json }) => {
          dispatch({ type: '@@iot/GET_SETTINGS' })
          app.go('/app/dashboard')
        })
        .catch(err => { message.error(err.message,err?.detail) })
      } 
    }
  }

  let timer = null
  const handleChange = (e) => {
    let value  = e.target.value
    if(timer) clearTimeout(timer)
    timer = setTimeout(() => {
      if(expireSettings?.length) {
        let tipFilter = expireSettings.filter(val => {
          return val?.expireTime && !val?.disable && moment(val?.expireTime).diff(new Date(), 's')>0
        })
        if(tipFilter?.length && tipFilter?.[0]?.code) {
          if(tipFilter?.[0]?.code == value) {
            let bodyStr = {
              pressMoney: {
                ...settings?.pressMoney,
                expireSettings: expireSettings.map(item => {
                  if(item?.expireTime && !item?.disable && moment(item?.expireTime).diff(new Date(), 's')<=0) {
                    return { ...item, disable: true }
                  }
                  return item
                })
              }
            }
            if(!user?.isAdmin) bodyStr.pressMoney._pressMoney = true
            api({ name: 'core/setting' })
            .fetch('', {
              method: 'PATCH',
              body: JSON.stringify(bodyStr)
            })
            .then(({ json }) => {
              message.success('密钥校验成功，重新加载即可访问')
              dispatch({ type: '@@iot/GET_SETTINGS' })
              setInputValue(null)
            })
            .catch(err => { message.error(err.message,err?.detail) })
          } else {
            message.error('密钥不正确！')
          }
        } 
      }
    }, 500)
  }

  const codeArr = expireSettings?.length ? expireSettings.filter(item => {
    const disable = moment(moment(item?.expireTime).subtract(item?.durationTime?.count, item?.durationTime?.unit)).diff(new Date(), 's')>0 ? false : !item?.disable ? !item?.disable : false
    if(disable && item?.code) return item
  }) : [] 

  const invalidExpire = (invalidArr) => {
    let newArr = []
    expireSettings.forEach(item => {
      invalidArr.forEach(val => {
        if(val?.expireTime == item?.expireTime && val?.disable == item?.disable && val?.tip == item?.tip) { 
          newArr.push( { ...item, disable: true } )
        } else {
          newArr.push(item)
        }
      })
    })
    let bodyStr = {
      pressMoney: {
        ...settings?.pressMoney,
        expireSettings: newArr
      }
    }
    if(!user?.isAdmin) bodyStr.pressMoney._pressMoney = true
    api({ name: 'core/setting' })
      .fetch('', {
        method: 'PATCH',
        body: JSON.stringify(bodyStr)
      })
      .then(({ json }) => {
        dispatch({ type: '@@iot/GET_SETTINGS' })
      })
      .catch(err => { message.error(err.message,err?.detail) })
  }

  const handleClick = async () => {
    if(user.isAdmin) { app.go('/app/dashboard'); return }
    let tipFilter = expireSettings.filter(val => {
      return val?.expireTime && !val?.disable && moment(val?.expireTime).diff(new Date(), 's')<=0
    })
    let nextTipFilter = null

    if(tipFilter.length>1) {
      let invalidArr = tipFilter.slice(1)
      await invalidExpire(invalidArr)
    } else {
      expireSettings.forEach((val, index) => {
        tipFilter.forEach(item => { 
          if(val?.expireTime == item?.expireTime && val?.disable == item?.disable && val?.tip == item?.tip) {
            nextTipFilter = expireSettings[index+1]
            return
          }
        })
      })
    }
   
    if(codeArr?.length && codeArr[0]?.code) {
      if(!tipFilter.length) {
        app.go('/app/dashboard')
      }
    } else if (tipFilter?.length && nextTipFilter) {
      resetDisable()
    }
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Result
        status="warning"
        title={messages}
        extra={
          <>
            {
              codeArr?.length && codeArr[0]?.code ?
                <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '2rem' }}>
                  <Col>密钥</Col>
                  <Col>
                    <Input style={{ marginLeft: '1rem', width: 200 }} 
                      placeholder="请输入密钥" 
                      onChange={handleChange}
                      /> 
                  </Col>
                </Row>
              : null
            }
            <Button type="primary" key="console" onClick={handleClick}>
              重新加载
            </Button>
          </>
        }
      />
    </div>
  )
}

export default {
  name: 'iot-permission417',
  routers: {
    '/': [
      {
        path: 'nopermission',
        component: PermissionPage
      },
    ]
  }
}
